<template>
  <div class="saved-filters">
    <saved-options-dropdown
      label="Saved Searches"
      :options="savedFilters"
      :save-disabled="!isFiltering || maxReached"
      :allow-deselect="allowDeselect"
      :hide-save="hideSave"
      :align="align"
      @edit="editSavedFilter"
      @delete="deleteSavedFilter"
      @select="selectSavedFilter"
      @save="showModal = true"
    />

    <save-filter-modal
      :type="type"
      :open="showModal"
      :query="query"
      :filters="filters"
      :editing="editing"
      @close="closeModal"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';

import { getFilterDescription } from '@cardladder/shared/utils/ladder.util';
import { SAVED_FILTERS_SIZE_LIMIT } from '@cardladder/shared/constants';

import SaveFilterModal from './SaveFilterModal';
import { authService } from '@/services';

export default {
  components: {
    SaveFilterModal,
  },

  props: {
    type: String,
    query: String,
    filters: Object,
    isFiltering: Boolean,
    hideSave: Boolean,
    allowDeselect: Boolean,
    align: {
      type: String,
      default: 'right',
    },
  },

  data() {
    return {
      listener: null,
      dbFilters: [],
      showModal: false,
      editing: null,
    };
  },

  mounted() {
    this.listener = authService.watchSavedFilters({
      uid: this.user.uid,
      type: this.type,
      onSnapshot: (snapshot) => {
        this.dbFilters = snapshot;
      },
    });
  },

  beforeDestroy() {
    this.listener();
  },

  watch: {
    dbFilters(filters, previousFilters) {
      if (this.type === 'shop' && previousFilters) {
        this.$store.commit('SET_LISTINGS_FEED', []);
      }
    },
  },

  computed: {
    ...mapState({
      user: (state) => state.user,
    }),

    savedFilters() {
      return this.dbFilters
        .map((filter) => {
          return {
            ...filter,
            active: this.isSelected(filter),
          };
        })
        .sort((a, b) => a.name?.localeCompare(b.name));
    },

    maxReached() {
      return this.savedFilters.length === SAVED_FILTERS_SIZE_LIMIT;
    },
  },

  methods: {
    isSelected(filter) {
      return getFilterDescription(filter.filters) === getFilterDescription(this.filters)
        && filter.query.trim() === this.query.trim();
    },

    editSavedFilter(filter) {
      this.editing = filter;
      this.showModal = true;
    },

    selectSavedFilter(filter) {
      this.$emit('select', filter);
    },

    async deleteSavedFilter(filter) {
      await authService.removeFromSavedFilters(this.user.uid, filter.id);
    },

    closeModal() {
      this.showModal = false;
      this.editing = null;
    },
  },
};
</script>
